/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  FormulaElementGroup,
  TakeOffParamSharedListItemDto,
  TakeOffParamsRestService,
} from '@gh/builder-shared-data';
import { DictionaryService } from '@gh/common-shared';
import { combineLatest$ } from '@gh/rx';
import { map$, switchMap$ } from '@gh/rx/operators';
import { assign, keyBy, map, sortBy, toLower } from 'lodash';
import { Observable } from 'rxjs';
import { FormulaContext } from '../formula-context';
import { FORMULA_DEFAULT_SNIPPETS, FORMULA_FUNCTIONS } from '../formula.constants';
import { ActivatableFormulaVariable, FormulaVariable, isFormulaVariableActive } from '../parser';

export const formulaVariableFromDto = (top: TakeOffParamSharedListItemDto) =>
  ({ id: top.takeOffParamId, name: top.code, active: top.isActive });

export const variablesToSnippets = (variables: FormulaVariable[]) => sortBy(map(variables, 'name'), toLower);

@Injectable()
export class FormulaContextLoader {
  constructor(private dictionaryService: DictionaryService,
              private takeOffParamRest: TakeOffParamsRestService) {

  }

  loadForEstimating(): Observable<FormulaContext> {
    return this.takeOffParamRest.findAllShared().pipe(
      map$((tops) => tops.map(formulaVariableFromDto)),
      switchMap$((variables) => this.loadForEstimatingWithVariables(variables)));
  }

  loadForEstimatingWithVariables(allVariables: ActivatableFormulaVariable[]): Observable<FormulaContext> {
    return combineLatest$(
      this.dictionaryService.getByEnum(FormulaElementGroup),
      this.dictionaryService.get('FORMULA_ERROR'),
    ).pipe(map$(([groups, errorBundle]) => {
      const activeVariables = allVariables.filter(isFormulaVariableActive);
      const snippets = assign({}, FORMULA_DEFAULT_SNIPPETS, {
        [FormulaElementGroup.TakeOffParams]: variablesToSnippets(activeVariables),
      });
// @ts-expect-error Legacy typing suppression
      return new FormulaContext(groups, keyBy(allVariables, 'id'), FORMULA_FUNCTIONS, errorBundle, snippets);
    }));
  }
}
